import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
export var SliderFillHorizontal = function (_a) {
    var style = _a.style;
    return React.createElement("div", { className: IdStyles.SliderFillHorizontal, style: style });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/SliderFillHorizontal.tsx
// module id = 2253
// module chunks = 3